// SVXS theme interactions
(function () {
  // Global reload tile-wipe overlay (diagonal mosaic)
  var overlay = document.getElementById('GlobalReloadTransition');
  if (overlay) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      overlay.remove();
    } else {
      var w = window.innerWidth;
      var cols = w >= 1000 ? 6 : (w >= 600 ? 4 : 3);
      var rows = w >= 1000 ? 4 : (w >= 600 ? 4 : 5);
      overlay.style.setProperty('--columns', cols);
      overlay.style.setProperty('--rows', rows);
      var frag = document.createDocumentFragment();
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var t = document.createElement('div');
          t.className = 'tile';
          t.style.setProperty('--row', r);
          t.style.setProperty('--col', c);
          frag.appendChild(t);
        }
      }
      overlay.appendChild(frag);
      overlay.style.background = 'transparent';
      var total = (rows - 1 + cols - 1) * 48 + 700 + 80;
      setTimeout(function () { overlay.remove(); }, total);
    }
  }

  // Announcement bar dismiss (persists per session)
  var ann = document.querySelector('[data-announcement]');
  if (ann) {
    try { if (sessionStorage.getItem('svxs-ann-dismissed')) ann.style.display = 'none'; } catch (e) {}
    var annClose = ann.querySelector('[data-announcement-close]');
    if (annClose) annClose.addEventListener('click', function () {
      ann.style.display = 'none';
      document.documentElement.style.setProperty('--ann-h', '0px');
      try { sessionStorage.setItem('svxs-ann-dismissed', '1'); } catch (e) {}
    });
  }

  // Newsletter popup
  var nl = document.querySelector('[data-newsletter]');
  if (nl) {
    var seen = false;
    try { seen = !!localStorage.getItem('svxs-nl-seen'); } catch (e) {}
    var delay = Number(nl.getAttribute('data-delay')) || 5000;
    var dismiss = function () {
      nl.classList.remove('is-open');
      try { localStorage.setItem('svxs-nl-seen', '1'); } catch (e) {}
    };
    if (!seen) setTimeout(function () { nl.classList.add('is-open'); }, delay);
    nl.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });
  }

  // Currency label toggle (display only)
  var cur = document.querySelector('[data-currency] span');
  if (cur) {
    var c = 'IDR';
    try { c = localStorage.getItem('svxs-currency') || 'IDR'; } catch (e) {}
    cur.textContent = c;
    cur.parentNode.addEventListener('click', function () {
      c = c === 'IDR' ? 'USD' : 'IDR';
      cur.textContent = c;
      try { localStorage.setItem('svxs-currency', c); } catch (e) {}
    });
  }

  // Product page: map selected options to variant id
  document.querySelectorAll('.product__form').forEach(function (form) {
    var idField = form.querySelector('input[name="id"]');
    var variants = window.__svxsVariants;
    if (!variants || !idField) return;
    form.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = Array.from(form.querySelectorAll('input[type="radio"]:checked')).map(function (i) { return i.value; });
        var match = variants.find(function (v) { return selected.every(function (s) { return v.options.includes(s); }); });
        if (match) idField.value = match.id;
      });
    });
  });
  // Homepage: header becomes solid on scroll
  var header = document.querySelector('.header');
  if (header && document.body.classList.contains('template-index')) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > window.innerHeight * 0.7); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  // Collection: grid density toggle
  var grid = document.querySelector('.product-grid--collection');
  document.querySelectorAll('.collection__views button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!grid) return;
      grid.setAttribute('data-cols', b.getAttribute('data-cols'));
      document.querySelectorAll('.collection__views button').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });
  // Cart: quantity stepper
  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('.cart__qty-input');
    var form = wrap.closest('[data-cart-form]');
    var updateBtn = form && form.querySelector('[data-cart-update]');
    if (!input) return;
    var setQty = function (next) {
      input.value = Math.max(0, next);
      if (updateBtn) updateBtn.click();
    };
    wrap.querySelector('[data-cart-qty-decrease]')?.addEventListener('click', function () {
      setQty(Number(input.value || 0) - 1);
    });
    wrap.querySelector('[data-cart-qty-increase]')?.addEventListener('click', function () {
      setQty(Number(input.value || 0) + 1);
    });
  });

  // Product images: add .is-loaded when finished loading (fade + scale reveal)
  document.querySelectorAll('.product-card__img--primary').forEach(function (img) {
    if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  });
})();
